import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { FileText } from 'lucide-react';
import { SEO } from '../utils/seo';
export function StatutsPage() {
  return <div className="min-h-screen bg-white" data-id="element-550">
      <SEO title="Statuts" description="Consultez les statuts officiels de l'Association Régionale de l'Industrie Hôtelière ARIH Agadir Souss Massa - Règles de fonctionnement et gouvernance" keywords="statuts ARIH, règlement ARIH, gouvernance association hôtelière" data-id="element-551" />
      <Navbar data-id="element-552" />

      {/* Hero */}
      <section className="bg-arih-blue py-24 md:py-32" data-id="element-553">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-554">
          <h1 className="text-[48px] md:text-[70px] font-semibold text-white leading-tight mb-6" data-id="element-555">
            Statuts de l'ARIH
          </h1>
          <p className="text-[20px] text-white/90 leading-[32px] max-w-2xl mx-auto" data-id="element-556">
            Téléchargez les statuts de l'Association Régionale de l'Industrie
            Hôtelière ARIH Agadir Souss Massa
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-white py-[120px]" data-id="element-557">
        <div className="container mx-auto px-4 md:px-8" data-id="element-558">
          <div className="max-w-2xl mx-auto text-center space-y-8" data-id="element-559">
            <div className="flex justify-center" data-id="element-560">
              <FileText className="h-20 w-20 text-arih-blue" data-id="element-561" />
            </div>

            <h2 className="text-[32px] md:text-[36px] font-bold text-arih-dark" data-id="element-562">
              Document officiel
            </h2>

            <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-563">
              Les statuts de l'ARIH Agadir Souss Massa définissent les règles de
              fonctionnement, les objectifs et la gouvernance de l'association.
            </p>

            <a href="https://drive.google.com/file/d/1ioRzrd6QiBd9lpO7WHi5FrwFUeApChjX/view" target="_blank" rel="noopener noreferrer" data-id="element-564">
              <Button className="bg-arih-blue text-white rounded-full px-12 py-3.5 h-auto text-[16px] font-semibold hover:bg-blue-800 transition-colors" data-id="element-565">
                Télécharger
              </Button>
            </a>
          </div>
        </div>
      </section>

      <Footer data-id="element-566" />
    </div>;
}